/*
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   useCardBackTextManagement.ts
 */

import { useRouteProps } from '@zcode-ui/hook'
import { selectCityName, selectHoodName, selectIsVertical } from '@zcode-ui/web-zumper-global-state'
import { useSelector } from 'react-redux'

export const useCardBackTextManagement = () => {
  const routeProps = useRouteProps()
  const { location, match } = routeProps
  const { params } = match
  // useRouteProps does not have correct type for params
  // @ts-expect-error
  const hasFilters = !!params?.filtersPath
  const hasAnySearch = !!location.search
  const isVertical = selectIsVertical(routeProps) && !hasAnySearch
  const isHood = !!useSelector(selectHoodName)
  const isCity = !!useSelector(selectCityName) && !isHood

  const shouldShowDefaultInfo = hasAnySearch || (hasFilters && !isVertical)
  const shouldFetchCardBack = shouldShowDefaultInfo || (isCity && !isVertical)

  return { isCity, isHood, isVertical, shouldShowDefaultInfo, shouldFetchCardBack }
}
